<template>
  <div class="acr-title">
    <h1>激活码管理</h1>
    <el-button class="acr-title-add-button" type="primary" v-on:click="importPropertyCodeData">导入激活码</el-button>
    <el-button class="acr-title-export-button" style="right: 90px" type="primary" v-on:click="exportPropertyCodeData">
      导出数据
    </el-button>
    <el-button class="acr-title-export-button" style="right: 165px" type="primary" v-on:click="downloadTemplate">
      下载导入模板
    </el-button>
    <!-- 导入资产弹出框 -->
    <ImportPropertyCode ref="ImportPropertyCode"></ImportPropertyCode>
    <!-- 条件搜索 -->
    <div>
      <el-input class="acr-search-input" placeholder="搜索条件为[ID/资产密码/用户ID/资产类型ID/兑换码ID]" v-model="searchKey"></el-input>
    </div>
  </div>
</template>

<script>

import ImportPropertyCode from "@/views/control/components/property/PropertyCode/ImportPropertyCode";
import AxiosBase from "@/components/axiosBase";

export default {
  name: "PropertyCodeTitle",
  components: {
    ImportPropertyCode
  },
  data() {
    return {
      searchKey: ''
    }
  },
  watch: {
    searchKey: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.length >= 3) {
        this.$parent.getPropertyCodeData();
      }
      if (newVal.length === 0) {
        this.$parent.getPropertyCodeData();
      }
    }
  },
  methods: {
    importPropertyCodeData() {
      this.$refs.ImportPropertyCode.dialogFormVisible = true;
    },
    exportPropertyCodeData() {
      AxiosBase.axiosGet("/property-ad/export-property-code").then(response => {
        if (response !== 0) {
          setTimeout(() => {
            window.open("https://raw.blendermagic.cn/export/excel/" + response.data)
          }, 2000)
        }
      })
    },
    downloadTemplate() {
      window.open("https://raw.blendermagic.cn/template/property.xls");
    },
  }
}
</script>

